import React from 'react';

import type { ThemeType } from '../../../@types';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import styles from './spinner.module.scss';

interface SpinnerProps {
  iconSize?: number;
  theme?: ThemeType;
}

const Spinner: React.FC<SpinnerProps> = ({ iconSize, theme }) => (
  <div className={styles.loader}>
    <Icon size={iconSize} theme={theme} icon={IconType.PROGRESS_ACTIVITY} />
  </div>
);

export default Spinner;
